// 搜索栏获取参数
class searchReq {
    public pageNo: number;
    public pageSize: number;               
    public state: string;   
    public recUniversity: string;
    public startDate: string;
    public jobName: string;

    constructor(){
        this.pageNo = 1;
        this.pageSize = 20;
        this.startDate = '';
        this.state = '';
        this.recUniversity = '';
        this.startDate = '';
        this.jobName = '';
    }
}

// 简历列表搜索栏参数
class BookingReq {
    public pageNo: number;
    public pageSize: number;               
    public university : string;

    constructor(){
        this.pageNo = 1;
        this.pageSize = 20;
        this.university = '';
    }
}

// 新增行程参数
class addFormData {
    public speechTime: any;
    public university: string;           
    public address: string;   
    public place: string;
    public regulation: string;
    public startDate: string;

    constructor(){
        this.speechTime = '';
        this.university = '';
        this.address = ''; 
        this.place = '';
        this.regulation = '';
        this.startDate = '';
    }
}





export {
    searchReq,
    addFormData,
    BookingReq
}